function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 23,
  y: 3,
  width: 23,
  height: 2,
  rx: 1,
  transform: "rotate(180 23 3)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.783 5.24a1 1 0 011.435-.002l5.49 5.64a1 1 0 01-1.415 1.415l-3.768-3.768V21a1 1 0 11-2 0V8.525l-3.762 3.762a1.008 1.008 0 01-1.436-1.414l5.456-5.633z"
});

function SvgVerticalAlignTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMjMiIHk9IjMiIHdpZHRoPSIyMyIgaGVpZ2h0PSIyIiByeD0iMSIgdHJhbnNmb3JtPSJyb3RhdGUoMTgwIDIzIDMpIiAvPgo8cGF0aCBkPSJNMTAuNzgzNCA1LjIzOTg4QzExLjE3NTcgNC44MzQ4NSAxMS44MjUxIDQuODM0MDkgMTIuMjE4NCA1LjIzODIxTDE3LjcwNzEgMTAuODc4N0MxOC4wOTc2IDExLjI2OTIgMTguMDk3NiAxMS45MDI0IDE3LjcwNzEgMTIuMjkyOUMxNy4zMTY2IDEyLjY4MzUgMTYuNjgzNCAxMi42ODM1IDE2LjI5MjkgMTIuMjkyOUwxMi41MjUxIDguNTI1MTVMMTIuNTI1MSAyMUMxMi41MjUxIDIxLjU1MjMgMTIuMDc3NCAyMiAxMS41MjUxIDIyQzEwLjk3MjggMjIgMTAuNTI1MSAyMS41NTIzIDEwLjUyNTEgMjFMMTAuNTI1MSA4LjUyNDg1TDYuNzYyNzcgMTIuMjg3MkM2LjM2OTI4IDEyLjY4MDcgNS43MzEzMyAxMi42ODA3IDUuMzM3ODQgMTIuMjg3MkM0Ljk0ODU3IDExLjg5NzkgNC45NDM4IDExLjI2ODMgNS4zMjcxNCAxMC44NzMxTDEwLjc4MzQgNS4yMzk4OFoiIC8+Cjwvc3ZnPgo=";
export { SvgVerticalAlignTop as ReactComponent };